import { useCallback } from 'react';
import { UseTicketListParams, useUpdateTodoMutation } from 'hooks/business/chat/useTicketMutations';
import { PureReturnOrders } from './PureReturnOrders';

interface ReturnOrdersProps {
  ticket: Todo.TodoInstance;
  listParams: UseTicketListParams | null;
  externalBuyerId: string;
  readonly?: boolean;
}

export const ReturnOrders = (props: ReturnOrdersProps) => {
  const { ticket, listParams, externalBuyerId, readonly = false } = props;
  const { id, relatedTradeId, relatedReturnId, storeId, platform } = ticket;

  const updateTodoMutation = useUpdateTodoMutation(listParams);

  const handleChange = useCallback(
    (returnSn: string) => {
      updateTodoMutation.mutate({
        id,
        relatedReturnId: returnSn,
      });
    },
    [id, updateTodoMutation],
  );

  return (
    <PureReturnOrders
      relatedTradeId={relatedTradeId}
      storeId={storeId}
      platform={platform}
      externalBuyerId={externalBuyerId}
      readonly={readonly}
      returnSn={relatedReturnId}
      onChange={handleChange}
      autoSelectFirst={Boolean(platform !== 'FACEBOOK')}
    />
  );
};
